'use strict';

/*
  notVerified - wants to be a local, needs to complete the profile
  and be reviewed by the admin.
  active - complete profile, reviewed by the admin, shown in the listing.
  notActive - complete profile, reviewed by the admin, not shown in the listing.
*/

const GUIDE_STATUS = {
  notVerified: 'notVerified',
  active: 'active',
  notActive: 'notActive'
};

const guideStatus = [
  '$http',
  '$q',
  'userModel',
  'utils',

  function ($http, $q, userModel, utils) {

    return {

      /**
       * Changes guide status.
       * @param newGuideStatus
       */
      setStatus: function (newGuideStatus) {
        var deferred = $q.defer();
        var data = {
          guideStatus: newGuideStatus
        };

        $http.post(utils.getApiUrl('/settings/' + userModel.item.id), data)
          .then(function (response) {
            if (response.data.guideStatus) {
              userModel.item.guideStatus = response.data.guideStatus.value;
            }

            deferred.resolve();
          })
          .catch(deferred.reject);

        return deferred.promise;
      },
      status: GUIDE_STATUS,

      /**
       * Change user's guide status to `notVerified` or `active` depending on his current guide status.
       */
      becomeGuide: function () {
        var newGuideStatus = userModel.item.guideStatus ? this.status.active : this.status.notVerified;

        return this.setStatus(newGuideStatus);
      },

      /**
       * Deactivates guide. If guide was not verified, he returns to initial state (guideStatus = false).
       */
      deactivate: function () {
        var newGuideStatus = this.isUnverifiedGuide() ? false : this.status.notActive;

        return this.setStatus(newGuideStatus);
      },

      /**
       * Returns true if current user has active or not verified guide status.
       * @returns {boolean}
       */
      isGuide: function () {
        return [
          this.status.notVerified,
          this.status.active,
        ].indexOf(userModel.item.guideStatus) > -1;
      },

      // because the new business rules make everyone who signs up "notVerified"
      newIsGuide: function () {
        return this.status.active === userModel.item.guideStatus;
      },

      /**
       * Returns true if current user has active guide status.
       * @returns {boolean}
       */
      isActiveGuide: function () {
        return userModel.item.guideStatus === this.status.active;
      },

      /**
       * Returns true if current user has not verified guide status.
       * @returns {boolean}
       */
      isUnverifiedGuide: function () {
        return userModel.item.guideStatus === this.status.notVerified;
      },

      /**
       * Returns true if current user has not active guide status.
       * @returns {boolean}
       */
      isInactiveGuide: function () {
        return userModel.item.guideStatus === this.status.notActive;
      }
    };
  }
];

export default guideStatus;



// WEBPACK FOOTER //
// ./app/src/services/guide_status.js